import { z } from 'zod'

import { ENV_SCHEMA } from '../env'

export const ENV_SCHEMA_OBJECT = z.object(ENV_SCHEMA)

export const APP_ENV = ENV_SCHEMA_OBJECT.parse(import.meta.env)
